import React, { FC } from 'react'

import { styled } from '@linaria/react'
import loadable from '@loadable/component'

import { IntersectionObserver } from 'components/layout/IntersectionObserver'

export const RobotView: FC = () => {
  return (
    <IntersectionObserver>
      {({ setNode, entry }) => {
        return (
          <RobotContainer ref={setNode}>
            <RobotWrapper>
              {entry?.isIntersecting ? <RobotLoadable /> : null}
            </RobotWrapper>
          </RobotContainer>
        )
      }}
    </IntersectionObserver>
  )
}

const RobotContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const RobotWrapper = styled.div`
  width: 232px;
  height: 244px;
`

const RobotLoadable = loadable(() => import('./Robot'))
